
export const validateDefaultUser = values => {
    const errors = {};

    if (!values.user_id) {
        errors.plan_id = 'This field is required';
    }
    return errors;
};